module.exports = __webpack_public_path__ + "static/for-businesses@2x-f1838b8f83367be3b6159382d07713c9.jpg";